<template>
    <div class="layout-search-bar-light relative">
        <button role="button" aria-label="Search" class="absolute left-0 h-full px-4 bg-transparent text-zinc-500">
            <icon-search></icon-search>
        </button>
        <button
            v-if="searchQuery"
            role="button"
            aria-label="Clear Search"
            class="absolute right-0 h-full px-4 bg-transparent text-zinc-500 hover:text-zinc-600"
            @click="clearSearch()"
        >
            <icon-close></icon-close>
        </button>
        <input
            ref="search"
            class="w-full px-14 py-4 rounded-md bg-white text-zinc-900 shadow-xs text-sm md:text-lg ring-1 ring-inset ring-zinc-300 focus:ring-1 focus:ring-inset focus:ring-zinc-300 placeholder:text-zinc-400 placeholder:text-sm md:placeholder:text-lg placeholder:italic focus-visible:outline-0 focus-active:outline-0"
            :placeholder="placeholder"
            :value="searchQuery"
            @input="(event) => makeSearch(event.target.value)"
        />
    </div>
</template>

<script>
export default {
    name: 'LayoutSearchBarLight',
    props: {
        placeholder: {
            required: false,
            type: String,
            default: 'Search...',
        },
        searchQuery: {
            required: true,
            type: String,
            default: '',
        },
        makeSearch: {
            required: true,
            type: Function,
        },
        focus: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    methods: {
        focusSearch() {
            let input = this.$refs['search'];
            this.$nextTick(() => {
                if (input && this.focus) input.focus();
            });
        },
        clearSearch() {
            this.makeSearch('');
        },
    },
    mounted() {
        this.focusSearch();
    },
};
</script>
